module.exports = __webpack_public_path__ + "static/media/rags.87f55025.png";